import e, { useState as T, useMemo as $, useCallback as B, useEffect as y } from "react";
import { useId as A } from "./utils/hooks/useId.esm.js";
const L = "_checkbox_f9tpk_3", N = "_checkboxBase_f9tpk_16", g = "_checkboxInput_f9tpk_22", w = "_checkboxLabel_f9tpk_28", R = "_checkboxTappableArea_f9tpk_71", F = "_checkboxError_f9tpk_156", M = "_checkboxErrorIcon_f9tpk_163", S = "_checkboxErrorText_f9tpk_173", o = {
  checkbox: L,
  "checkbox--full-width": "_checkbox--full-width_f9tpk_8",
  "checkbox--margin-bottom": "_checkbox--margin-bottom_f9tpk_12",
  checkboxBase: N,
  checkboxInput: g,
  checkboxLabel: w,
  checkboxTappableArea: R,
  checkboxError: F,
  checkboxErrorIcon: M,
  checkboxErrorText: S
};
function z({
  children: l,
  name: t,
  analyticsId: _ = "",
  className: n = "",
  dataTestId: p = null,
  errorMessageId: f,
  isChecked: a = !1,
  isDisabled: u = !1,
  isError: i = !1,
  onChange: b = null,
  value: d = "",
  componentId: r,
  ...m
}) {
  const [E, k] = T(!!a), s = A(), h = $(
    () => `${t}_${r || s}`,
    [t, r || s]
  ), I = B(
    (c) => {
      var x;
      k((x = c == null ? void 0 : c.target) == null ? void 0 : x.checked), typeof b == "function" && b(c);
    },
    [b]
  );
  return y(() => {
    k(a);
  }, [a]), /* @__PURE__ */ e.createElement("div", { className: `${o.checkboxBase} fuse-checkbox__base-checkbox` }, /* @__PURE__ */ e.createElement(
    "input",
    {
      name: t,
      "aria-describedby": f || void 0,
      "data-analyticsid": _,
      "data-testid": p,
      checked: E,
      className: `${o.checkboxInput} ${n || ""} fuse-checkbox__input`,
      disabled: !!u,
      id: h,
      onChange: I,
      type: "checkbox",
      value: d,
      ...m
    }
  ), /* @__PURE__ */ e.createElement(
    "label",
    {
      "aria-invalid": i || void 0,
      htmlFor: h,
      className: `${o.checkboxLabel} fuse-checkbox__label`
    },
    /* @__PURE__ */ e.createElement("span", { className: `${o.checkboxTappableArea} fuse-checkbox__tappable-area` }, l)
  ));
}
export {
  z as B,
  o as s
};
